import {defineNuxtRouteMiddleware, navigateTo} from '#app';
import {useAuth} from '#imports';
import {RouteNames} from '~/configuration/routeNames';

export default defineNuxtRouteMiddleware((to) => {
    const connectedFreelancerCompanyId = useAuth().getSelectedIdentity?.freelancerCompanyId;

    if (!connectedFreelancerCompanyId) {
        return navigateTo('/', {external: true});
    }

    return navigateTo({
        name: RouteNames.RQTH,
        params: {id: connectedFreelancerCompanyId},
        query: {...to.query},
    });
});
